import React from 'react';
import { withSelectEnumHOC } from 'core/components/HOCs/SelectEnumHOC';
import startCase from 'lodash/startCase';

import { RigTypeList } from './enums';

const Select = withSelectEnumHOC(RigTypeList, true, startCase);

function RigTypeSelect(props: any): JSX.Element {
  return <Select {...props} />;
}

RigTypeSelect.defaultProps = {
  value: RigTypeList.semi,
};

export { RigTypeSelect };
